<app-dialog-base modalId="removeParameterConfirmModal" title="Remove parameter from diagnostic service" [itemTemplate]="removeParameterConfirmTemplate" applyCaption="Yes" (modalApply)="apply()" (modelCancel)="cancel()"></app-dialog-base>

<ng-template #removeParameterConfirmTemplate>
    <div class="sdds-banner">
        <div class="sdds-banner-body">
            Are you sure to remove the selected parameter?
        </div>
    </div>
</ng-template>